module.exports = __webpack_public_path__ + "static/media/kano.8179f95d.png";